import styled, { css } from 'styled-components';

import { Container } from '@/components/Container';

import { ReactComponent as PrintSvg } from '@/assets/Print.svg';
export const Wrapper = styled(Container)<{ $isHeading: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  ${({ $isHeading }) =>
    !$isHeading &&
    css`
      flex-direction: row-reverse;
    `};
`;
export const PrintBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;
export const PrintText = styled.div`
  font-size: 14px;
  text-decoration: underline;
  line-height: 22px;
  ${({ theme }) => css`
    color: ${theme.colors.primary};
    font-family: ${theme.fontFamilies.openSans};
  `};
`;

export const PrintIcon = styled(PrintSvg)`
  width: 16px;
  height: 16px;
  ${({ theme }) => css`
    margin-right: ${theme.spacing(1)};
  `};
`;
